
export default class Ajax {

    constructor() {

    }

    makeRequest(method: string, datapool: object, data: object, async: boolean) {
        method = typeof method !== 'undefined' ? method : 'GET';
        async = typeof async !== 'undefined' ? async : false;

        //@ts-ignore
        let url = datapool.ajaxurl + (typeof data.action != 'undefined' ? '?action='+data.action : '');

        if (window.XMLHttpRequest){
            var xhReq = new XMLHttpRequest();
        }

        if (method == 'POST'){
            xhReq.open(method, url, async);
            xhReq.setRequestHeader("Content-type", "application/json");
            xhReq.setRequestHeader("X-Requested-With", "XMLHttpRequest");
            xhReq.send(JSON.stringify(data));
        } else {
            xhReq.open(method, url, async);
            xhReq.setRequestHeader("X-Requested-With", "XMLHttpRequest");
            xhReq.send(null);
        }

        return xhReq;

    }
}

